import Header from "./Header";
import Footer from "./Footer";
import DashboardSidebar from "./Sidebar";
import GetActiveSubscriptions from "./Dashboard/ActiveSubscription";
import { useState } from "react";
import Usage from "./Dashboard/Usage";
import Billing from "./Dashboard/Billing";
import Alerts from "./Dashboard/Alerts";
import Matrix from "./Dashboard/Matrix";

function Dashboard() {

    const [sectionName, useSectionName] = useState("Active Subscriptions");

    return (
        <>
            <div className="container-fluid px-5 py-2">
                <Header />
                <main className="row" style={{ minHeight: "65vh" }}>
                    <DashboardSidebar useSectionNameFn={useSectionName} />

                    <div className="container-dashboard px-4 py-2" id="featured-3">

                        {
                            (sectionName == "Active Subscriptions") ?
                                <GetActiveSubscriptions />
                                // : (sectionName == "Usage") ?
                                //     <Usage UserSubscriptionID={66} />
                                : (sectionName == "Billing") ?
                                    <Billing />
                                    // : (sectionName == "Alerts") ?
                                    //     <Alerts />
                                    : (sectionName == "Matrix") ?
                                        <Matrix />
                                        : <GetActiveSubscriptions />

                        }

                    </div>
                </main >

            </div >
            <Footer />
        </>
    );
}

export default Dashboard;